<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-info shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/brand/docs-01.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Standards</h4>
                                <p class="text-white">Quality+ has developed a series of standards that can be used by IOs and/or sending institutions in connection with their VET mobilities for learners. The standards target the schools/IOs, the learners and the Host Companies. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg">
            <div class="container">
                <div class="row">
                    <div class="col-md-2 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree2.svg'" class="card-img">
                        </div>
                    </div>
                    <div class="col-md-10 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Memorandum of Understanding between the School and Intermediary Organisation</h6>
                            <p class="description mt-3">The Memorandum of Understanding (MoU) applies when the VET mobility is implemented in cooperation with an Intermediary Organisation (IO). The MoU sets the terms of cooperation between the sending institution and the IO. The standard can be adjusted to reflect the specific agreements between the two stakeholders.</p>
                            <base-button tag="a" href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_Memorandum_Digital_Form.pdf?alt=media&token=8eb7b82d-4cd8-422a-a3eb-889ed6876784" type="primary" class="mt-5" target="_BLANK">
                                Download the MoU template
                            </base-button>
                        </card>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-2 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree.svg'" class="card-img">
                        </div>
                    </div>
                    <div class="col-md-10 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Student Commitment Form</h6>
                            <p class="description mt-3">The Student Commitment Form targets the learners who undertakes a VET mobility and it urges the learner to reflect on their responsibilities before, during and after the mobility. The standard can be adjusted to reflect any particularity.</p>
                            <div class="row">
                                <div class="col-md-6">
                                    <base-button tag="a" href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FStudent_Commitment_Form_FINAL.pdf?alt=media&token=a6baadba-f2a6-4388-bcb2-183a6befc502" type="primary" class="mt-5 mx-0" target="_BLANK">
                                        Download the Student Commitment Form
                                    </base-button>
                                </div>
                                <div class="col-md-6">
                                    <base-button tag="a" @click="show" href="#" type="primary" class="mt-5 ml-2">
                                        Watch the Student Commitment video
                                    </base-button>
                                </div>
                            </div>


                        </card>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-2 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree.svg'" class="card-img">
                        </div>
                    </div>
                    <div class="col-md-10 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Student Profile Form</h6>
                            <p class="description mt-3">The Student Profile Form a template to present to present the Host Companies the learner’s practical experience, skills, and learning objectives. The standard can be used in the planning phase of the VET mobility in order to identify a suitable placement.</p>
                            <base-button tag="a" href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FStudentProfileForm_Final.pdf?alt=media&token=ac07f0dd-3657-44fb-a499-a319e991a314" type="primary" class="mt-5" target="_BLANK">
                                Download the Student Profile Form Template
                            </base-button>
                        </card>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-2 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree2.svg'" class="card-img">
                        </div>
                    </div>
                    <div class="col-md-10 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Standard Diploma for Host Companies</h6>
                            <p class="description mt-3">The Standard Diploma for Host Companies can be used by IOs or sending institutions to recognise the efforts of Host Companies.</p>
                            <base-button tag="a" href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_HostCompaniesDiplomas.zip?alt=media&token=e1a4d03a-19b4-414e-ac27-1d62b193e1d9" type="primary" class="mt-5">
                                Download the Standard Diploma
                            </base-button>
                        </card>
                    </div>
                </div>
                <modal height="auto" width="80%" name="my-first-modal">
                    <div>
                        <div class="player-container">
                            <Media 
                                :kind="'video'"
                                :controls="true"
                                :src="['https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/video%2FStudent%20Commitment%20Video.mp4?alt=media&token=624f20ba-fb9d-4128-9c44-47254a164c6b']"
                                :style="{width: '100%'}"
                                :autoplay="true"
                                :loop="false"

                            >
                            </Media>
                        </div>
                    </div>
                </modal>
            </div>
        </section>

    </div>
</template>

<script>
import VueCoreVideoPlayer from 'vue-core-video-player'
import Media from '@dongido/vue-viaudio'

// Vue.use(VueCoreVideoPlayer, {
//   lang: 'en-EN'
// })

export default {
  name: "home",
  components: {
      Media
  },
  methods: {
        show () {
            this.$modal.show('my-first-modal');
        },
        hide () {
            this.$modal.hide('my-first-modal');
        }
  }
};
</script>
